// PDP upsells (#39/#40). Adds the upsell without opening the cart overlay, so
// the customer can carry on with the main product: the button changes to
// "Added" and the header cart count updates. This posts to /cart/add.js
// itself rather than using the theme's ShopifyAPI.addItemFromForm, which
// fires ajaxCart.afterAddItem, and the product section's listener for that
// opens the overlay. The overlay reloads the cart whenever it opens. Without
// JS, without the cart overlay, or if the add fails, the form posts to
// /cart/add as normal.
class ProductUpsell extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('[data-ref-button]');
    this.status = this.querySelector('[data-ref-status]');
    this.addEventListener('submit', (event) => this.add(event));
  }

  async add(event) {
    if (window.theme?.data?.cartMethod !== 'modal') return;

    event.preventDefault();
    const form = event.target;
    this.button.disabled = true;

    try {
      const response = await fetch(window.theme.routes?.cart_add_url || '/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form),
      });
      if (!response.ok) throw response;
    } catch {
      form.submit();
      return;
    }

    // Stays "Added" (and disabled) until the page reloads
    this.button.textContent = this.dataset.addedLabel;
    this.button.classList.add('is-added');
    this.status.textContent = this.dataset.addedMessage;
    this.updateCartCount();
  }

  async updateCartCount() {
    const countRef = document.querySelector('[data-ref-cart-count]');
    if (!countRef) return;

    try {
      const response = await fetch(window.theme.routes?.cart_url || '/cart.js', { headers: { Accept: 'application/json' } });
      if (!response.ok) return;
      const cart = await response.json();
      countRef.textContent = cart.item_count;
    } catch {
      // The count catches up the next time the cart loads
    }
  }
}

customElements.define('component-product-upsell', ProductUpsell);
